<template>
    <div>
        <section class="exam-content m0 cb pr">
            <article class="fl exam-left">
                <h3 class="tc h3">{{laseExamList.name}}</h3>
                <div class="exam-score-wrap m0">
                    <div class="exam-score-left fl">
                        <div class="score fl">
                            <p class="m0 tc">
                                <i class="m0">
                                    <img src="/static/images/score.png" alt/>
                                </i>
                                <span class="clearfix f14 tc mt10">您的得分</span>
                            </p>
                        </div>
                        <div class="fl fx">
                            <p class="m0 tc">
                                <span class="f14 tc">{{questionTotals.score}}</span>
                                /{{questionTotals.totalScore}}
                            </p>
                        </div>
                    </div>
                    <div class="exam-score-left exam-score-right fr">
                        <div class="score fl">
                            <p class="m0 tc">
                                <i class="m0">
                                    <img src="/static/images/correct.png" alt/>
                                </i>
                                <span class="clearfix f14 tc mt10">答对题数</span>
                            </p>
                        </div>
                        <div class="fl fx">
                            <p class="m0 tc">
                                <span class="f14 tc">{{questionTotals.questionCount}}</span>
                                /{{questionTotals.totalQuestionCount}}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="exam-nav cb mb20">
                    <ul class="m0" v-for="(item,index) in questionTypeSummaries" :key="index">
                        <li class="first" v-if="item.type == '001001'">
                            <a
                                    href="javascript:;"
                                    :class="{ active: type == '001001' }"
                                    @click="menuBtn('001001');"
                            >单选题</a>
                        </li>
                        <li v-if="item.type == '001002'">
                            <a
                                    href="javascript:;"
                                    :class="{ active: type == '001002' }"
                                    @click="menuBtn('001002');"
                            >多选题</a>
                        </li>
                        <li v-if="item.type == '001003'">
                            <a
                                    href="javascript:;"
                                    :class="{ active: type == '001003' }"
                                    @click="menuBtn('001003');"
                            >判断题</a>
                        </li>
                        <li v-if="item.type == '001004'">
                            <a
                                    href="javascript:;"
                                    :class="{ active: type == '001004' }"
                                    @click="menuBtn('001004');"
                            >填空题</a>
                        </li>
                        <li v-if="item.type == '001005'">
                            <a
                                    href="javascript:;"
                                    :class="{ active: type == '001005' }"
                                    @click="menuBtn('001005');"
                            >简答题</a>
                        </li>
                        <li v-if="item.type == '001006'">
                            <a
                                    href="javascript:;"
                                    :class="{ active: type == '001006' }"
                                    @click="menuBtn('001006');"
                            >案例题</a>
                        </li>
                    </ul>
                </div>
                <div class="examOverscroll fl">
                    <div
                            class="option-question m0 active"
                            v-for="(item,index) in questionTypeSummaries"
                            :key="index"
                    >
                        <!--单选题-->
                        <div v-show="item.type == '001001' && item.type == type">
                            <p class="explainText mt20 pl10">一、{{item.description}}</p>
                            <div class="option-div" v-for="(questionsItem,index) in item.questions" :key="index">
                                <i class="fl mr10 active">{{index+1}}</i>
                                <h2 class="f14 fl" v-html="questionsItem.content"></h2>
                                <div class="option-list-radio ml40 cb"
                                     v-for="(choicesItem,index) in questionsItem.choices"
                                     :key="index"
                                >
                                    <div class="oh">
                                        <el-radio v-model="questionsItem.userAnswer" :label="choicesItem.code">
                                            <span>{{choicesItem.code}}</span>
                                        </el-radio>
                                        <div class="oh fl" style="margin-top: 5px">
                                            <span v-html="choicesItem.content" class="exam-words fl"> </span>
                                        </div>
                                    </div>
                                </div>

                                <div class="result pt20 ml40 cb">
                                    <p class="f14 cuo">
                                        您的答案：{{questionsItem.userAnswer}}
                                        <i
                                                v-if="questionsItem.userAnswer != questionsItem.answer"
                                        >
                                            <img src="/static/images/cha_03.png" alt/>
                                        </i>
                                        <i v-if="questionsItem.userAnswer == questionsItem.answer">
                                            <img src="/static/images/dui_07.png" alt/>
                                        </i>
                                    </p>
                                    <p class="f14 dui" v-if="laseExamList.ifDisplayAnswer">
                                        <span>正确答案为：</span>
                                        {{questionsItem.answer}}
                                        <i>
                                            <img src="/static/images/dui_07.png" alt/>
                                        </i>
                                    </p>
                                    <div class="f14 jiexi" v-if="laseExamList.ifDisplayAnswer">
                                        <span class="fl">解析:</span>
                                        <p v-html="questionsItem.analysis" class="fl ml5"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--多选题-->
                        <div v-show="item.type == '001002' && item.type == type">
                            <p class="explainText mt20 pl10">一、{{item.description}}</p>
                            <div class="option-div" v-for="(questionsItem,index) in item.questions" :key="index">
                                <i class="fl mr10 active">{{index+1}}</i>
                                <h2 class="f14 fl" v-html="questionsItem.content"></h2>
                                <div class="result pt20 ml40 cb">
                                    <p class="f14 cuo">
                                        您的答案：{{questionsItem.userAnswer}}
                                        <i
                                                v-if="questionsItem.userAnswer != questionsItem.answer"
                                        >
                                            <img src="/static/images/cha_03.png" alt/>
                                        </i>
                                        <i v-if="questionsItem.userAnswer == questionsItem.answer">
                                            <img src="/static/images/dui_07.png" alt/>
                                        </i>
                                    </p>
                                    <p class="f14 dui" v-if="laseExamList.ifDisplayAnswer">
                                        <span>正确答案为：</span>
                                        {{questionsItem.answer}}
                                        <i>
                                            <img src="/static/images/dui_07.png" alt/>
                                        </i>
                                    </p>
                                    <div class="f14 jiexi" v-if="laseExamList.ifDisplayAnswer">
                                        <span class="fl">解析:</span>
                                        <p v-html="questionsItem.analysis" class="fl ml5"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--判断题-->
                        <div v-show="item.type == '001003' && item.type == type">
                            <p class="explainText mt20 pl10">一、{{item.description}}</p>
                            <div class="option-div" v-for="(questionsItem,index) in item.questions" :key="index">
                                <i class="fl mr10 active">{{index+1}}</i>
                                <h2 class="f14 fl" v-html="questionsItem.content"></h2>
                                <div class="result pt20 ml40 cb">
                                    <p class="f14 cuo">
                                        您的答案：{{questionsItem.userAnswer}}
                                        <i
                                                v-if="questionsItem.userAnswer != questionsItem.answer"
                                        >
                                            <img src="/static/images/cha_03.png" alt/>
                                        </i>
                                        <i v-if="questionsItem.userAnswer == questionsItem.answer">
                                            <img src="/static/images/dui_07.png" alt/>
                                        </i>
                                    </p>
                                    <p class="f14 dui" v-if="laseExamList.ifDisplayAnswer">
                                        <span>正确答案为：</span>
                                        {{questionsItem.answer}}
                                        <i>
                                            <img src="/static/images/dui_07.png" alt/>
                                        </i>
                                    </p>
                                    <div class="f14 jiexi" v-if="laseExamList.ifDisplayAnswer">
                                        <span class="fl">解析:</span>
                                        <p v-html="questionsItem.analysis" class="fl ml5"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--填空题-->
                        <div v-show="item.type == '001004' && item.type == type">
                            <p class="explainText mt20 pl10">一、{{item.description}}</p>
                            <div
                                    class="option-div option-div-tk"
                                    v-for="(questionsItem,index) in item.questions"
                                    :key="index"
                            >
                                <i class="fl mr10 active">{{index+1}}</i>
                                <h2 class="f14 fl" v-html="questionsItem.content"></h2>
                                <div class="result pt20 ml40 cb option-div-tk">
                                    <p class="f14 cuo">
                                        您的答案：{{questionsItem.userAnswer}}
                                        <i
                                                v-if="questionsItem.userAnswer != questionsItem.answer"
                                        >
                                            <img src="/static/images/cha_03.png" alt/>
                                        </i>
                                        <i v-if="questionsItem.userAnswer == questionsItem.answer">
                                            <img src="/static/images/dui_07.png" alt/>
                                        </i>
                                    </p>
                                    <p class="f14 dui" v-if="laseExamList.ifDisplayAnswer">
                                        <span>正确答案为：</span>
                                        {{questionsItem.answer}} 
                                        <i>
                                            <img src="/static/images/dui_07.png" alt/>
                                        </i>
                                    </p>
                                    <div class="f14 jiexi" v-if="laseExamList.ifDisplayAnswer">
                                        <span class="fl">解析:</span>
                                        <p v-html="questionsItem.analysis" class="fl ml5"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--简答题-->
                        <div v-show="item.type == '001005' && item.type == type">
                            <p class="explainText mt20 pl10">一、{{item.description}}</p>
                            <div class="option-div" v-for="(questionsItem,index) in item.questions" :key="index">
                                <div class="question-box">
                                    <i class="fl mr10 active">{{ index+1 }}</i>
                                    <h2 class="f14 fl" v-html="questionsItem.content"></h2>
                                </div>
                                <div class="result pt20 ml40 cb">
                                    <p class="f14 cuo">
                                        您的答案：{{questionsItem.userAnswer}}
                                        <i
                                                v-if="questionsItem.userAnswer != questionsItem.answer"
                                        >
                                            <img src="/static/images/cha_03.png" alt/>
                                        </i>
                                        <i v-if="questionsItem.userAnswer == questionsItem.answer">
                                            <img src="/static/images/dui_07.png" alt/>
                                        </i>
                                    </p>
                                    <p class="f14 dui" v-if="laseExamList.ifDisplayAnswer">
                                        <span>正确答案为：</span>
                                        <span v-html="questionsItem.answer"></span>
                                        <i>
                                            <img src="/static/images/dui_07.png" alt/>
                                        </i>
                                    </p>
                                    <div class="f14 jiexi" v-if="laseExamList.ifDisplayAnswer">
                                        <span class="fl">解析:</span>
                                        <p v-html="questionsItem.analysis" class="fl ml5"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--案例题-->
                        <div v-show="item.type == '001006' && item.type == type">
                            <p class="explainText mt20 pl10">一、{{item.description}}</p>
                            <div class="option-div" v-for="(questionsItem,index) in item.questions" :key="index">
                                <div class="question-box">
                                    <i class="fl mr10 active">{{ index+1 }}</i>
                                    <h2 class="f14 fl" v-html="questionsItem.content"></h2>
                                </div>
                                <div class="result pt20 ml40 cb">
                                    <p class="f14 cuo">
                                        您的答案：{{questionsItem.userAnswer}}
                                        <i
                                                v-if="questionsItem.userAnswer != questionsItem.answer"
                                        >
                                            <img src="/static/images/cha_03.png" alt/>
                                        </i>
                                        <i v-if="questionsItem.userAnswer == questionsItem.answer">
                                            <img src="/static/images/dui_07.png" alt/>
                                        </i>
                                    </p>
                                    <p class="f14 dui" v-if="laseExamList.ifDisplayAnswer">
                                        <span>正确答案为：</span>
                                        <span v-html="questionsItem.answer"></span>
                                        <i>
                                            <img src="/static/images/dui_07.png" alt/>
                                        </i>
                                    </p>
                                    <div class="f14 jiexi" v-if="laseExamList.ifDisplayAnswer">
                                        <span class="fl">解析:</span>
                                        <p v-html="questionsItem.analysis" class="fl ml5"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </article>
            <article class="fr exam-right">
                <div class="exam-right-box">
                    <div class="exam-txbox mt15 fl">
            <span class="pr fl">
              <i>
                <img src="/static/images/tx-vip_03.png" alt/>
              </i>
              <img :src="userHeadImagUrl" alt width="53" height="53" style="display:block;border-radius:50px"/>
            </span>
                        <p class="fl">
                            <span>-{{realName}},上午好</span>
                            <span class="fl">总分 :</span>
                            <span class="fl score">&nbsp;&nbsp;{{ laseExamList.totalScore }}分</span>
                        </p>
                    </div>
                    <div class="sign-title fr">
                        <p>
              <span class="f12">
                <img src="/static/images/dt-bj.png" alt height="25"/>
                未答
              </span>
                            <span class="f12">
                <img src="/static/images/dt-bj3.png" alt height="25"/>
                已答
              </span>
                        </p>
                    </div>
                </div>
                <!--倒计时-->
                <div class="count-down count-down2">
                    <div class="collect-table mt20">
                        <ul>
                            <li></li>
                            <li v-for="(item,index) in questionTypeSummaries" :key="index">
                                <span v-if="item.type == '001001'" class="f12">单选</span>
                                <span v-if="item.type == '001002'" class="f12">多选</span>
                                <span v-if="item.type == '001003'" class="f12">判断</span>
                                <span v-if="item.type == '001004'" class="f12">填空</span>
                                <span v-if="item.type == '001005'" class="f12">简答</span>
                                <span v-if="item.type == '001006'" class="f12">案例</span>
                            </li>
                        </ul>
                        <table border="0" class="cb">
                            <tr>
                                <th width="51" height="36">答对</th>
                                <td
                                        v-for="(item,index) in questionScores"
                                        :key="index"
                                        width="51"
                                        height="36"
                                >{{item.right}}
                                </td>
                            </tr>
                            <tr>
                                <th width="51" height="36">答错</th>
                                <td
                                        v-for="(item,index) in questionScores"
                                        :key="index"
                                        width="51"
                                        height="36"
                                >{{item.error}}
                                </td>
                            </tr>
                            <tr>
                                <th width="51" height="36">未答</th>
                                <td
                                        v-for="(item,index) in questionScores"
                                        :key="index"
                                        width="51"
                                        height="36"
                                >{{item.empty}}
                                </td>
                            </tr>
                            <tr>
                                <th width="51" height="36">得分</th>
                                <td
                                        v-for="(item,index) in questionScores"
                                        :key="index"
                                        width="51"
                                        height="36"
                                >{{item.score}}
                                </td>
                            </tr>
                        </table>
                    </div>
                    <p class="hand-over f14 tc"></p>
                </div>
                <div class="selection-card">
                    <div class="exam-nav">
                        <ul class="m0" v-for="(item,index) in questionTypeSummaries" :key="index">
                            <li v-if="item.type == '001001'">
                                <a
                                        href="javascript:;"
                                        :class="{ active: type == '001001' }"
                                        @click="menuBtn('001001');"
                                >单选题</a>
                            </li>
                            <li v-if="item.type == '001002'">
                                <a
                                        href="javascript:;"
                                        :class="{ active: type == '001002' }"
                                        @click="menuBtn('001002');"
                                >多选题</a>
                            </li>
                            <li v-if="item.type == '001003'">
                                <a
                                        href="javascript:;"
                                        :class="{ active: type == '001003' }"
                                        @click="menuBtn('001003');"
                                >判断题</a>
                            </li>
                            <li v-if="item.type == '001004'">
                                <a
                                        href="javascript:;"
                                        :class="{ active: type == '001004' }"
                                        @click="menuBtn('001004');"
                                >填空题</a>
                            </li>
                            <li v-if="item.type == '001005'">
                                <a
                                        href="javascript:;"
                                        :class="{ active: type == '001005' }"
                                        @click="menuBtn('001005');"
                                >简答题</a>
                            </li>
                            <li v-if="item.type == '001006'">
                                <a
                                        href="javascript:;"
                                        :class="{ active: type == '001006' }"
                                        @click="menuBtn('001006');"
                                >案例题</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <!--选项卡-->
                <div class="optionsBox oh">
                    <div class="option-block m0" v-for="(item,index) in questionTypeSummaries" :key="index">
                        <p v-for="(questionsItem,index) in item.questions" :key="index">
                            <a
                                    class="tc"
                                    v-show="type == '001001'&& item.type==type"
                                    :class="{ unanswered: !questionsItem.userAnswer}"
                            >{{index+1}}</a>
                            <a
                                    class="tc"
                                    v-show="type == '001002'&& item.type==type"
                                    :class="{ unanswered: !questionsItem.userAnswer}"
                            >{{index+1}}</a>
                            <a
                                    class="tc"
                                    v-show="type == '001003' && item.type==type"
                                    :class="{ unanswered: !questionsItem.userAnswer}"
                            >{{index+1}}</a>
                            <a
                                    class="tc"
                                    v-show="type == '001004' && item.type==type"
                                    :class="{ unanswered: !questionsItem.userAnswer}"
                            >{{index+1}}</a>
                            <a
                                    class="tc"
                                    v-show="type == '001005' && item.type==type"
                                    :class="{ unanswered: !questionsItem.userAnswer}"
                            >{{index+1}}</a>
                            <a
                                    class="tc"
                                    v-show="type == '001006'&& item.type==type "
                                    :class="{ unanswered: !questionsItem.userAnswer}"
                            >{{index+1}}</a>
                        </p>
                    </div>
                </div>
            </article>
            <div class="page-bj cb"></div>
        </section>
    </div>
</template>
<style scoped>
    .collect-table ul li {
        display: block;
        float: left;
        width: 51px;
        height: 36px;
        line-height: 36px;
        background: #f9f9f9;
        border-top: 1px solid #e6e6e6;
        border-left: 1px solid #e6e6e6;
        text-align: center;
        color: #666;
    }

    .collect-table ul li:last-child {
        border-right: 1px solid #e6e6e6;
    }
</style>
<script>
    import ft from "../Footer"
    import headTop from "../Top"
    import '../../../static/css/exam-content.css'

    export default {
        data() {
            return {
                laseExamList: [],
                questionTypeSummaries: [],
                type: '001001',
                types: '001001',
                realName: '',
                userHeadImagUrl: '',
                rightCountAll: 0,//正确值
                questionScores: [],
                questionTotals: {
                    score: 0,
                    totalScore: 0,
                    questionCount: 0,
                    totalQuestionCount: 0
                },
            }
        },
        methods: {
            examScoreData() {
                this.lastExamRecordId = this.$route.query.id;
                this.$axiosPackag.getMessageByAxios("POST", "/api/student/onlineExam/viewRecord", {"recordId": this.lastExamRecordId}, null, null, res => {
                    this.laseExamList = res
                    this.questionTypeSummaries = res.questionTypeSummaries
                    //初始化数据
                    this.questionScores = []
                    this.questionTotals = {
                        score: 0,
                        totalScore: res.totalScore,
                        questionCount: 0,
                        totalQuestionCount: 0
                    };
                    //答题汇总 对，错，未答，总分
                    var firstIndex = "";
                    for (var i = 0; i < this.questionTypeSummaries.length; i++) {
                        let questionScore = {
                            // type: this.questionTypeSummaries[i].type,
                            // title: this.questionTypeSummaries[i].description.split('，')[0],
                            right: 0,
                            error: 0,
                            empty: 0,
                            score: 0
                        };
                        for (var j = 0; j < this.questionTypeSummaries[i].questions.length; j++) {
                            if (parseFloat(this.questionTypeSummaries[i].questions[j].userScore) > 0) {
                                questionScore.right++;
                                questionScore.score += parseFloat(this.questionTypeSummaries[i].questions[j].userScore);
                                this.questionTotals.score += parseFloat(this.questionTypeSummaries[i].questions[j].userScore);
                                this.questionTotals.questionCount += 1;
                            } else if (this.questionTypeSummaries[i].questions[j].userAnswer) {
                                questionScore.error++;
                            } else {
                                questionScore.empty++;
                            }
                            this.questionTotals.totalQuestionCount += 1;
                            this.questionTypeSummaries[i].questions[j].content = this.$util.html(this.questionTypeSummaries[i].questions[j].content)
                            this.questionTypeSummaries[i].questions[j].analysis = this.$util.html(this.questionTypeSummaries[i].questions[j].analysis)
                            this.questionTypeSummaries[i].questions[j].answer = this.$util.html(this.questionTypeSummaries[i].questions[j].answer)
                            if (this.questionTypeSummaries[i].questions[j].choices) {
                                for (var q = 0; q < this.questionTypeSummaries[i].questions[j].choices.length; q++) {
                                    this.questionTypeSummaries[i].questions[j].choices[q].content = this.$util.html(this.questionTypeSummaries[i].questions[j].choices[q].content)
                                }
                            }
                            let type = this.questionTypeSummaries[i].questions[j].type;
                            if (firstIndex == '') {
                                firstIndex = type;
                            }
                        }
                        this.questionScores.push(questionScore);
                    }
                    this.menuBtn(firstIndex);
                });
            },
            menuBtn(type) {
                this.type = type;
            },
            menuBtns(types) {
                this.types = types;
            },
        },
        components: {
            headTop,
            ft
        },
        mounted() {
            this.examScoreData();
            this.realName = this.$sessionStore.getRealName();
            this.$axiosPackag.getMessageByAxios("GET", "/api/student/user/getUser", null, null, null, resD => {
                if (resD) {
                    this.realName = resD.realName;
                    this.userHeadImagUrl = resD.picture;
                }
            });
        }
    }
</script>



// WEBPACK FOOTER //
// ExamScore.vue?2d17b03c